import { Badge } from '@uag/react-core';
import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/shallow';

import { inputContexts } from 'app/modules/wallforming/components/input-binding/registry/inputActionsRegistry';
import { resolveInputContext } from 'app/modules/wallforming/components/input-binding/utils/inputContextUtils';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

export const InputContextStatus = () => {
    const { t } = useTranslation();
    const context = usePlacementStore(useShallow(resolveInputContext));
    const metadata = inputContexts[context];

    return (
        <Badge className="ml-2" icon={metadata.icon} size="normal">
            {t(metadata.labelKey)}
        </Badge>
    );
};
